"use strict";
/**
 * description: 从个人素材库上传视频
 * created by he.zhikai
 * created on 2017-08-10
 */
angular.module('trsPersonalVideoUploadDirective', [])
    .directive('trsPersonalVideoUpload', ['$q', 'trsHttpService', 'personalFileService', function($q, trsHttpService, personalFileService) {
        return {
            restrict: 'EA',
            replace: true,
            transclude: true,
            scope: {
                callback: '='
            },
            templateUrl: './components/util/trsPersonalVideoUpload/trsPersonalVideoUpload_tpl.html',
            controller: function($scope, $element) {},
            link: function(scope, element, attr) {
                /**
                 * [upload description] 上传
                 * @return {[type]} [description]
                 */
                scope.upload = function() {
                    personalFileService.openPersonalFile("3", function(data) {
                        var videoArray = [];
                        for (var i = 0; i < data.length; i++) {
                            videoArray.push({ AUDIOVIDEOID: data[i].VIDEOID, STORAGE: '2' });
                        }
                        scope.callback(videoArray);
                    });
                };

            }
        };
    }]);